<template>
<div class="popup" v-show="editCloudShow" v-cloak>
    <div v-if="cloudName == 'egnyte'">
            <div id="editEgnyteCloud" class="content" ref="editEgnyteCloud"
                :class="[multipleChoiceArr.includes(cloudName) ? 'amazonS3-content' : '', specialTipsCloud.includes(cloudName) ? 'threeInput-content' : '']"
                :style="{ height: tipShow ? boxHeight : getStyleHeight(cloudName) }">
                <div class="title">
                    <span> {{ $t('language.leftBanner.edit') }} {{ $t('language.addCloud.' + cloudType) }}</span>
                    <div class="icon white-close dialog-close"
                        @click.stop="editCloudShow = false, inputCloudNameValue = ''">
                    </div>
                </div>
                <div class="add-cloud-cont">
                    <div class="add-cloud-cont-top">
                        <div class="add-cloud-drive-position">
                            <div class="cloud add-cloud-size" :class="cloudType"></div>
                            <span class="add-cloud-text">
                                <b>{{ $t('language.addCloud.' + cloudType) }}</b>
                            </span>
                        </div>
                    </div>
                    <div class="add-egnyteEditcloud-cont-body" :class="cloudName == 'amazonS3' ? 'amazonS3-body' : ''">
                        <div class="cloud-cont add-egnyteEdit-des" v-show="cloudName == 'egnyte'">
                            <div class="icon-util egnyte-tip "> </div>
                            <div class="add-egnyteEditTip" style="position:relative;left:10Px;"
                                v-html="$t('language.popup.addCloudPopup.egnyteTip')"></div>
                        </div>
                        <div class="cloud-cont">
                            <div class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.displayName') }}
                            </div>
                            <input type="text" v-model="inputCloudNameValue" class="egnyteCloud-cont-input"
                                :placeholder="$t('language.addCloud.' + cloudName)"
                                :class="cloudName == 'amazonS3' || cloudName == 'wasabi' ? 'cloud-amazonS3-input' : ''"
                                :style="{ width: (this.$i18n.locale == 'italian' && (cloudName == 'iCloudPhotos' || cloudName == 'iCloudDrive')) ? '450Px' : '' }">
                        </div>
                        <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                            <font class="cloud-cont-name">{{ $t('language.popup.email') }}</font>
                            <input type="text" v-model="email" class="egnyteCloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                            <font class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.passWord') }}</font>
                            <input type="password" v-model="password" class="egnyteCloud-cont-input">
                        </div>
                        <button class="add-drive-submit"
                            :style="{ bottom: passwordArr.includes(cloudName) ? -5 + 'px' : '' }" @click="rewriteDrive"
                            v-show="cloudName != 'iCloudPhotos' || cloudName != 'iCloudDrive'">
                            <span v-show="!connect">{{ $t('language.common.save') }}&nbsp;&nbsp;{{ $t('language.addCloud.' +
                                cloudName) }}</span>
                            <span v-show="connect">{{ $t('language.common.connecting') }}
                                <span class="cloudDotting"></span>
                            </span>
                        </button>

                        <!-- 如果云盘类型为egnyte -->
                        <div class="cloud-cont" v-show="cloudName == 'egnyte'">
                            <font class="cloud-cont-name">{{ $t('language.popup.domain') }}</font>
                            <input type="text" v-model="domain" class="egnyteCloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'egnyte'">
                            <font class="cloud-cont-name">{{ $t('language.popup.key') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="key" class="egnyteCloud-cont-input">
                        </div>
                        <div class="cloud-cont" v-show="cloudName == 'egnyte'">
                            <font class="cloud-cont-name">{{ $t('language.popup.secret') }}</font>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="secret" class="egnyteCloud-cont-input">
                        </div>
                        <div class="question-mark addwebdav-icon-position" v-show="cloudName == 'egnyte'"
                            style="positon:relative;" @mouseout="explanShow = false" @mouseover="explanShow = true">
                            <div class="icon-util questions-edit "> </div>
                            <div class="egnyte-explanation explanation">
                                <font v-html="$t('language.popup.addCloudPopup.' + cloudName + 'Question')"></font>
                            </div>
                        </div>

                        <div v-show="!unTips.includes(cloudName) && !emailClouds.includes(cloudName)">
                            <div style="cursor:pointer;" @click="tipShow = !tipShow"><span class="add-cloud-tips">{{
                                $t('language.popup.tips') }}</span>
                                <span class="icon-util folding-panel slide"
                                    :class="tipShow ? 'folding-panel-up' : 'folding-panel-down'"></span>
                            </div>
                            <div class="add-drive-footer">
                                <transition name="tip-slide" v-cloak>
                                    <div class="add-cloud-info" v-show="tipShow" ref=container><span
                                            v-html="$t('language.popup.addCloudPopup.' + cloudName + 'Tips')"></span></div>
                                </transition>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    <div v-else-if="cloudName == 'Icedrive'">
        <div id="editIcedrive" class="content" ref="editIcedrive" :class="[multipleChoiceArr.includes(cloudName)?'amazonS3-content':'',specialTipsCloud.includes(cloudName)?'threeInput-content':'']" :style="{height:tipShow?boxHeight:getStyleHeight(cloudName)}">
        <div class="title">
            <span> {{$t('language.leftBanner.edit')}} {{$t('language.addCloud.'+cloudType)}}</span>
            <div class="icon white-close dialog-close" @click.stop="editCloudShow=false,inputCloudNameValue=''"></div>
        </div>
        <div class="add-icedrive-cont">
            <div class="add-cloud-cont-top">
                <div class="add-cloud-drive-position">
                    <div class="cloud add-cloud-size" :class="cloudType"></div>
                    <span class="add-cloud-text">
                        <b>{{$t('language.addCloud.'+cloudType)}}</b>
                    </span>
                </div>
            </div>
            <div class="add-icedrive-cont-body" :class="cloudName=='amazonS3'?'amazonS3-body':''">
                <div class="cloud-cont add-icedrive-des" v-show="cloudName == 'Icedrive'">
                            <div class="icon-util icedrive-tip "> </div>
                            <div class="add-icedriveTip" style="position:relative;left:10Px;"
                                v-html="$t('language.popup.addCloudPopup.icedriveTip')">
                            </div>
                </div>
                <div class="cloud-cont">
                            <div class="cloud-cont-name">{{ $t('language.popup.addCloudPopup.displayName') }}</div>
                            <input :style="{ width: this.$i18n.locale == 'italian' ? '450Px' : '' }" type="text"
                                v-model="inputCloudNameValue" class="cloud-cont-input"
                                :placeholder="$t('language.addCloud.' + cloudName)"
                                :class="cloudName == 'amazonS3' ? 'cloud-amazonS3-input' : ''">
                </div>
                <div v-show="threeInput.includes(cloudName)">
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.email')}}</font>
                        <input type="text" v-model="email" class="cloud-cont-input" >
                    </div>
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                        <input type="password" v-model="password" class="cloud-cont-input">
                    </div>
                </div>
                        <button class="add-drive-submit"
                            :style="{ bottom: passwordArr.includes(cloudName) ? -5 + 'px' : '' }" @click="rewriteDrive"
                            v-show="cloudName != 'iCloudPhotos' || cloudName != 'iCloudDrive'">
                            <span v-show="!connect">{{ $t('language.common.save') }}&nbsp;&nbsp;{{ $t('language.addCloud.' +
                                cloudName) }}</span>
                            <span v-show="connect">{{ $t('language.common.connecting') }}
                                <span class="cloudDotting"></span>
                            </span>
                        </button>
            </div>
        </div>
        </div>
    </div>
<div v-else>
    <div id="editCloud" class="content" ref="editCloud" :class="[multipleChoiceArr.includes(cloudName)?'amazonS3-content':'',specialTipsCloud.includes(cloudName)?'threeInput-content':'']" :style="{height:tipShow?boxHeight:getStyleHeight(cloudName)}">
        <div class="title">
            <span> {{$t('language.leftBanner.edit')}} {{$t('language.addCloud.'+cloudType)}}</span>
            <div class="icon white-close dialog-close" @click.stop="editCloudShow=false,inputCloudNameValue=''"></div>
        </div>
        <div class="add-cloud-cont">
            <div class="add-cloud-cont-top">
                <div class="add-cloud-drive-position">
                    <div class="cloud add-cloud-size" :class="cloudType"></div>
                    <span class="add-cloud-text">
                        <b>{{$t('language.addCloud.'+cloudType)}}</b>
                    </span>
                </div>
            </div>
            <div class="add-cloud-cont-body" :class="cloudName=='amazonS3'?'amazonS3-body':''">
                           <!-- 如果云盘类型为4shared -->
                <div class="cloud-cont add-4shared-des" v-show="cloudName == 'fourShared'">
                            <div class="icon-util egnyte-tip "> </div>
                            <div class="add-4sharedEditTip" style="position:relative;left:10Px;"
                                v-html="$t('language.popup.addCloudPopup.fourShared')"></div>
                </div>
                <div class="cloud-cont">
                    <div class="cloud-cont-name">{{$t('language.popup.addCloudPopup.displayName')}}
                </div>
                    <input type="text" v-model="inputCloudNameValue" class="cloud-cont-input" :placeholder="$t('language.addCloud.'+cloudName)" :class="cloudName=='amazonS3'||cloudName=='wasabi'?'cloud-amazonS3-input':''"
                    :style="{width:(this.$i18n.locale =='italian'&&(cloudName=='iCloudPhotos' || cloudName=='iCloudDrive'))?'450Px':''}">
              </div>
                <!-- 如果云盘类型为webDav -->
                <div v-show="serveCloudArr.includes(cloudName)">
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.server')}}</font>
                        <input type="text" class="ftp-cont-right-one" v-if="cloudName=='mySQL'" v-model="serverNumber">
                        <input type="text" class="ftp-cont-right-one" v-if="cloudName!='mySQL'" v-model="portNumber">
                        <input type="text" class="ftp-cont-input" v-if="cloudName=='webDav'" v-model="webDavserverHttp" style="width:290px;/*no*/">
                        <input type="text" class="ftp-cont-input" v-if="cloudName!='webDav'" v-model="otherServerHttp" style="width:290px;/*no*/">
                    </div>
                    <!-- 显示问号 -->
                    <div class="question-mark" id="cloudQuestionMark" @mouseleave="explanShow=false" @mouseover="explanShow=true">
                        <div class="icon-util question three-icon-position">
                            <div class="webdav-explanation explanation" v-if="explanShow">
                                <font v-html="$t('language.popup.addCloudPopup.'+cloudName+'Question')"></font>
                            </div>
                        </div>
                    </div>
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.userName')}}</font>
                        <input type="text" v-model="username" class="cloud-cont-input">
                    </div>
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                        <input v-model="password" type="password" class="cloud-cont-input">
                    </div>

                </div>
                <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                    <font class="cloud-cont-name">{{$t('language.popup.email')}}</font>
                    <input type="text" v-model="email" class="cloud-cont-input">
                </div>
                <div class="cloud-cont" v-show="passwordArr.includes(cloudName)">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                    <input type="password" v-model="password" class="cloud-cont-input">
                </div>
                <div class="cloud-cont" v-show="cloudName=='amazonS3'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.bucketName')}}</font>
                    <input type="text" v-model="bucketName" class="cloud-cont-input" :class="cloudName=='amazonS3'?'cloud-amazonS3-input':''">
                </div>
                <div class="cloud-cont" v-show="cloudName=='amazonS3'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.accessKeyId')}}</font>
                    <input type="text" v-model="accessKey" class="cloud-cont-input" :class="cloudName=='amazonS3'?'cloud-amazonS3-input':''">
                </div>
                <!-- 显示问号 -->
                <div class="question-mark " v-show="cloudName=='amazonS3'" id="cloudQuestionMark">
                    <div class="icon-util question three-icon-position " id="mark"> </div>
                    <div class="amazon-explanation mark-all">
                        <font v-html="$t('language.popup.addCloudPopup.amazonQuestion')"></font>
                    </div>
                </div>
                <div class="cloud-cont" v-show="cloudName=='amazonS3'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.secretAccessKey')}}</font>
                    <input type="passWord" v-model="secretAccessPassword" class="cloud-cont-input" :class="cloudName=='amazonS3'?'cloud-amazonS3-input':''">
                </div>
                <button class="add-drive-submit" :style="{bottom:passwordArr.includes(cloudName)?-5+'px':''}" @click="rewriteDrive" v-show="cloudName!='iCloudPhotos' || cloudName!='iCloudDrive'">
                    <span v-show="!connect">{{$t('language.common.save')}}&nbsp;&nbsp;{{$t('language.addCloud.'+cloudName)}}</span>
                    <span v-show="connect">{{$t('language.common.connecting')}}
                        <span class="cloudDotting"></span>
                    </span>
                </button>

                <!-- 如果云盘类型为ADrive -->
                <div v-show="threeInput.includes(cloudName)">
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.email')}}</font>
                        <input type="text" v-model="email" class="cloud-cont-input" >
                    </div>
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                        <input type="password" v-model="password" class="cloud-cont-input">
                    </div>
                </div>
                <div v-show="userNameInput.includes(cloudName)">
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.userName')}}</font>
                        <input type="text" v-model="username" class="cloud-cont-input">
                    </div>
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                        <input type="password" v-model="password" class="cloud-cont-input">
                    </div>
                </div>
                <!-- 如果云盘类型为backblaze -->
                <div class="cloud-cont" v-show="cloudName=='backblaze'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.bucketName')}}</font>
                    <input type="text" v-model="bucketName" class="cloud-cont-input" :class="cloudName=='amazonS3'?'cloud-amazonS3-input':''">
                </div>
                <div class="cloud-cont" v-show="cloudName=='backblaze'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.keyID')}}</font>
                    <input type="text" v-model="keyID" class="cloud-cont-input" :class="cloudName=='amazonS3'?'cloud-amazonS3-input':''">
                </div>
                <div class="cloud-cont" v-show="cloudName=='backblaze'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.applicationKey')}}</font>
                    <input type="text" v-model="applicationKey" class="cloud-cont-input" :class="cloudName=='amazonS3'?'cloud-amazonS3-input':''">
                </div>

                <div class="cloud-cont" v-if="cloudName=='webDav'||cloudName == 'ownCloud'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.path')}}</font>
                    <input type="text" v-if="cloudName=='webDav'" v-model="path" class="cloud-cont-input">
                    <input type="text" v-if="cloudName =='ownCloud'" v-model="ownCloudpath" class="cloud-cont-input">
                </div>

                <div class="add-cloud-info" v-show="cloudName=='gSuite'"> <span v-html="$t('language.popup.addCloudPopup.gSuiteUpTips')"></span></div>

               <!-- wasabi -->

                <div class="cloud-cont" v-show="cloudName=='wasabi'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.accessKeyId')}}</font>
                    <input type="text" v-model="wasabiAccessKey" class="cloud-cont-input" :class="cloudName=='wasabi'?'cloud-amazonS3-input':''">
                </div>
                <div class="cloud-cont" v-show="cloudName=='wasabi'">
                    <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.secretAccessKey')}}</font>
                    <input type="passWord" v-model="wasabiSecretAccessPassword" class="cloud-cont-input" :class="cloudName=='wasabi'?'cloud-amazonS3-input':''">
                </div>

                <div v-show="!unTips.includes(cloudName)&&!emailClouds.includes(cloudName)">
                    <div style="cursor:pointer;" @click="tipShow=!tipShow"><span class="add-cloud-tips">{{$t('language.popup.tips')}}</span>
                        <span class="icon-util folding-panel slide" :class="tipShow?'folding-panel-up':'folding-panel-down'"></span>
                    </div>
                    <div class="add-drive-footer">
                        <transition name="tip-slide" v-cloak>
                            <div class="add-cloud-info" v-show="tipShow" ref=container><span v-html="$t('language.popup.addCloudPopup.'+cloudName+'Tips')"></span></div>
                        </transition>
                    </div>
                </div>
                <!-- 如果云盘是iCloudPhotos或者iCloudDrive -->
                <div v-show="cloudName=='iCloudPhotos' || cloudName === 'iCloudDrive'">
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.appleId')}}</font>
                        <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="text" v-model="appleId" class="cloud-cont-input">
                    </div>
                    <div class="cloud-cont">
                        <font class="cloud-cont-name">{{$t('language.popup.addCloudPopup.passWord')}}</font>
                        <input :style="{width:this.$i18n.locale =='italian'?'450Px':''}" type="password" v-model="password" class="cloud-cont-input">
                    </div>
                    <button class="add-drive-submit" @click="rewriteDrive">
                        <span v-show="!connect">{{$t('language.common.save')}}&nbsp;&nbsp;{{$t('language.addCloud.'+cloudName)}}</span>
                        <span v-show="connect">
                            {{$t('language.common.connecting')}}
                            <span class="cloudDotting"></span>
                        </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    </div>
    <checkAppleDialog ref="checkAppleDialog"></checkAppleDialog>
</div>
</template>

<script>
import addCloudUtils from '@/js/workspace/add_cloud_utils.js';
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";

import checkAppleDialog from '@/components/popup/add_cloud_popups/check_apple_popup';
export default {
    props: ['cloudType', 'cloudId'],
    data: function () {
        return {
            editCloudShow: false,
            inputCloudNameValue: '',
            bucketName: '',
            accessKey: '',
            wasabiAccessKey:'',
            secretAccessPassword: '',
            wasabiSecretAccessPassword:'',
            //新加的数据项
            cloudInfo: {},
            cloudName: '',
            cloudIcon: '',
            inputCloudNameValue: '',
            bucketName: '',
            accessKey: '',
            secretAccessPassword: '',
            connect: false,
            tipShow: false,
            unTips: [],
            emailClouds: [],
            email: "",
            password: "",
            passwordArr: ['mega', 'mediafire'],
            boxHeight: '',
            webDavserverHttp: 'https://',
            portNumber: 443,
            advancedShow: false,
            explanShow: false, //用于定义弹框是否显示
            serveCloudArr: ['ownCloud', 'webDav', 'mySQL'],
            multipleChoiceArr: ['ownCloud', 'webDav', 'amazonS3', 'mySQL', 'backblaze'],
            username: '',
            serverNumber: '3306',
            otherServerHttp: '',
            domain: '',
            key: '',
            secret: '',
            threeInput: ['aDrive', 'sugarSync', 'WEBDE', 'cubby','Icedrive'], //用于表示输入项目为名称、密码、邮箱的input
            userNameInput: ['myDrive', 'yandex', 'hiDrive', 'cloudMe'], //用于表示输入项目为名称、用户名、密码的input
            path: '',
            ownCloudpath: '/remote.php/webdav/',
            keyID: '',
            applicationKey: '',
            specialTipsCloud: ['yandex', 'mediafire', 'aDrive', 'hiDrive', 'WEBDE', 'cloudMe', 'myDrive', 'cubby', 'sugarSync', 'Icedrive'],
            appleId: '',
        }
    },
    components: {
        checkAppleDialog,
    },
    created() {
        this.unTips = commonstate.unTips;
        this.emailClouds = commonstate.emailClouds;
    },
    methods: {
        getStyleHeight(cloudName){
            let result;
           if(this.multipleChoiceArr.includes(this.cloudName)){
               result=445+'Px';
               if(this.cloudName=='amazonS3'||this.cloudName=='backblaze'){
                result=365+'Px';
               }
            }else{
                result=315+'Px';
            }
            return result;

        },
        emailVerification() {
            if (!commonstate.emailpattern.test(this.email) && this.email) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "editEgnyteCloud";
                } else if(this.cloudName === 'Icedrive') {
                    idValues = "editIcedrive";
                }else {
                    idValues = "editCloud";
                }
                this.$toast({
                    text: this.$t('language.login.enterCorrectEmai'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }
        },
        rewriteDrive() {
            this.connect = true;
            let that = this;
            //对输入框进行校验
            if (!this.inputCloudNameValue) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "editEgnyteCloud";
                } else if(this.cloudName === 'Icedrive') {
                    idValues = "editIcedrive";
                } else {
                    idValues = "editCloud";
                }
                that.$toast({
                    text: this.$t('language.exception.nameEmpty'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }//判断是否特殊字符
            if (commonstate.patternDriveName.test(this.inputCloudNameValue)) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "editEgnyteCloud";
                } else if(this.cloudName === 'Icedrive') {
                    idValues = "editIcedrive";
                } else {
                    idValues = "editCloud";
                }
                that.$toast({
                    text: that.$t('language.home.driveNameNotContain'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }//判断是否有参数为空
            if (commonstate.threeParamDrives.includes(this.cloudName)) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "editEgnyteCloud";
                } else if(this.cloudName === 'Icedrive') {
                    idValues = "editIcedrive";
                } else {
                    idValues = "editCloud";
                }
                if (!this.email) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: idValues
                    });
                    this.connect = false;
                    return false;
                }
            }//判断是否是ownCloud和mySQL有参数为空
            if (this.cloudName == 'ownCloud' || this.cloudName == 'mySQL') {
                if (!this.otherServerHttp) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "editCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }//判断是否有参数为空
            if (commonstate.userNameParamDrives.includes(this.cloudName) || this.cloudName == 'webDav' || this.cloudName == 'ownCloud' || this.cloudName == 'mySQL') {
                if (!this.username) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "editCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }//判断是否有参数为空
            if (!this.password && this.cloudName != 'amazonS3' && this.cloudName != 'egnyte' && this.cloudName != 'backblaze' && this.cloudInfo.authParams && this.cloudInfo.authParams.length != 1) {
                let idValues;
                if (this.cloudName == 'Icedrive') {
                    idValues = "editIcedrive";
                } else {
                    idValues = "editCloud";
                }
                that.$toast({
                    text: this.$t('language.exception.parametersNotEmpty'),
                    type: 'fail',
                    idValue: idValues,
                });
                this.connect = false;
                return false;
            }
            
            //判断是否有参数为空
            if (this.cloudName == 'egnyte' && (!this.domain || !this.key || !this.secret)) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "editEgnyteCloud";
                } else {
                    idValues = "editCloud";
                }
                that.$toast({
                    text: this.$t('language.exception.parametersNotEmpty'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }//判断是否有参数为空
            if (this.cloudName == 'amazonS3') {
                if (!this.bucketName || !this.accessKey || !this.secretAccessPassword) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "editCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            if (this.cloudName == 'wasabi') {
                if (!this.wasabiAccessKey || !this.wasabiSecretAccessPassword) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "editCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //判断是否有参数为空
            if (!this.bucketName && this.cloudName == 'backblaze') {
                that.$toast({
                    text: this.$t('language.exception.parametersNotEmpty'),
                    type: 'fail',
                    idValue: "editCloud"
                });
                this.connect = false;
                return false;
            }//判断是否有参数为空
            if (this.cloudName == 'backblaze') {
                if (!this.keyID || !this.applicationKey) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "editCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //如果是iCloudPhotos或iCloudDrive云盘，有些参数没输则弹窗提醒
            if (this.cloudName == 'iCloudPhotos' || this.cloudName == 'iCloudDrive') {
                if (!this.appleId || !this.password) {
                    that.$toast({
                        text: this.$t('language.exception.parametersNotEmpty'),
                        type: 'fail',
                        idValue: "editCloud"
                    });
                    this.connect = false;
                    return false;
                }
            }
            //判断名称是否超过200
            if (this.inputCloudNameValue.length > 200) {
                let idValues;
                if (this.cloudName === 'egnyte') {
                    idValues = "editEgnyteCloud";
                } else if(this.cloudName === 'Icedrive') {
                    idValues = "editIcedrive";
                } else {
                    idValues = "editCloud";
                }
                that.$toast({
                    text: that.$t('language.home.cloudDiskName'),
                    type: 'fail',
                    idValue: idValues
                });
                this.connect = false;
                return false;
            }
            let user = commonUtils.getUser();
            let redirectUrl = commonstate.addCloudRedirectUrl;
            let  patternStpName = new RegExp("(:\\d+)?(?=((?<!\/)\/[^\/])|(\/?$))");
            let rewriteData;
            //若是只有一个参数
            if (!commonstate.specialDrives.includes(this.cloudName)) {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, null, null, null, null, null, null, this.cloudName, null, null, redirectUrl);
                //若含有三个参数
            } else if (commonstate.threeParamDrives.includes(this.cloudName)) {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.email, this.password, null, null, null, null, this.cloudName, null, null, redirectUrl);
                //若是其他特殊云盘
            } else if (commonstate.userNameParamDrives.includes(this.cloudName)) {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.username, this.password, null, null, null, null, this.cloudName, null, null, redirectUrl);
                //若是其他特殊云盘
            } else if (this.cloudName == 'webDav') {
                 let  server=this.webDavserverHttp.replace(patternStpName,':'+this.portNumber);
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.username, this.password, null, server, null, null, this.cloudName, null, this.path, redirectUrl);
            } else if (this.cloudName == 'ownCloud') {
                 let  server = this.otherServerHttp.replace(patternStpName,':'+this.portNumber);
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.username, this.password, null, server, null, null, this.cloudName, null, this.ownCloudpath, redirectUrl);
            } else if (this.cloudName == 'amazonS3') {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.accessKey, this.secretAccessPassword, null, null, null, this.bucketName, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'wasabi') {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.wasabiAccessKey, this.wasabiSecretAccessPassword, null, null, null,null, this.cloudName, null, null, redirectUrl);
            }else if (this.cloudName == 'mySQL') {
                let server = this.otherServerHttp + ':' + this.serverNumber;
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.username, this.password, null, server, null, null, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'egnyte') {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.key, this.secret, this.domain, null, null, null, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'backblaze') {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.keyID, null, null, null, this.applicationKey, this.bucketName, this.cloudName, null, null, redirectUrl);
            } else if (this.cloudName == 'iCloudPhotos' || this.cloudName == 'iCloudDrive') {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, this.appleId, this.password, null, null, null, null, this.cloudName, null, null, redirectUrl);
                let checkApple = this.$refs.checkAppleDialog;
                //如果有验证信息
                if(checkApple.authUrl&&checkApple.code){
                    rewriteData.authUrl = checkApple.authUrl;
                    rewriteData.cs = checkApple.cs;
                    rewriteData.code = checkApple.code;
                }
            } else {
                rewriteData = new addCloudUtils.reWriteCloudData(user.id, this.cloudId, this.inputCloudNameValue, null, null, null, null, null, null, this.cloudName, null, null, redirectUrl);
            }
            this.Utils.doDrivesRequest("re-write", rewriteData).then(res => {
                if (res.status == 201) {
                    this.Utils.openWin(res);
                    this.inputCloudNameValue = '';
                    this.editCloudShow = false;
                    this.connect = false;
                } else if (res.status == 200) {
                    if(this.cloudName == 'iCloudPhotos' || this.cloudName == 'iCloudDrive'){
                        if(res.authUrl){
                            this.connect = false;
                            //如果是iCloudPhotos或者是iCloudDrive，并且返回了authUrl地址，则跳转到验证界面
                            this.$refs.checkAppleDialog.initShow(res.authUrl,this.cloudName,"edit");
                            return;
                        }else{
                            //iCloudPhotos校验成功需要关闭验证弹窗
                            this.$refs.checkAppleDialog.isShow = false;
                        }
                    }
                    this.inputCloudNameValue = '';
                    this.connect = false;
                    //下面的editStoreDrive会报错，导致编辑弹窗不关闭，所以把这一行提到前面来
                    this.editCloudShow = false;
                    //把编辑过的云盘数据存入云盘缓存进行封装
                    addCloudUtils.editStoreDrive(res.drive,that);
                } else {
                    this.connect = false;
                    if (this.cloudName == 'mega') {//如果添加的mega云盘报错，则单独弹窗
                        this.$toast({
                            text: this.$t('language.exception.addMegaFailed'),
                            type: 'fail',
                            idValue: "editCloud"
                        });
                    } else {
                        //如果是iCloudPhotos的验证码错误
                        if(res.reason == 'verifyCodeInvalid' && this.cloudName == 'iCloudPhotos'){
                            //重置验证码
                           this.$refs.checkAppleDialog.$refs.codeInput.init();
                        }
                         //如果是iCloudDrive的验证码错误
                         if(res.reason == 'verifyCodeInvalid' && this.cloudName == 'iCloudDrive'){
                            //重置验证码
                           this.$refs.checkAppleDialog.$refs.codeInput.init();
                        }
                        if (this.cloudName == 'Icedrive') {
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "editIcedrive"
                        });
                        } else {
                        this.$toast({
                            text: this.$t('language.exception.' + res.reason),
                            type: 'fail',
                            idValue: "editCloud"
                        });
                    }
                }
                }
            });
        }
    }
}
</script>

<style>
/*设置下拉框新增样式*/
.cloud-edit-submit {
    width: 200px;
    /*no*/
    float: right;
    position: absolute;
    bottom: 0;
    right: 0;
}

#editCloud {
    width: 680px;
    /*no*/
    height: 275px;
    /*no*/
    min-height: 300Px;
}
#editIcedrive {
    width: 680px;
    /*no*/
    height: 275px;
    /*no*/
    min-height: 390Px;
}
#editEgnyteCloud {
    width: 680px;
    /*no*/
    height: 275px;
    /*no*/
    min-height: 450Px;
}
.add-egnyteEdit-des {
    color: rgba(0, 0, 0, 0.55);
    background-color: #F0F8FF;
    padding: 20px;
    border-radius: 6px;
    margin-top: 17px;
    margin-bottom: 20px;
    padding-top: 19px;
    /* 上边距较大 */
    padding-bottom: 10px;
    /* 下边距较小 */
    width: 588px !important;
}

.add-4shared-des {
    color: rgba(0, 0, 0, 0.55);
    background-color: #F0F8FF;
    padding: 20px;
    border-radius: 6px;
    margin-top: 12px;
    margin-bottom: 20px;
    padding-top: 10px;
    /* 上边距较大 */
    padding-bottom: 10px;
    /* 下边距较小 */
    width: 588px !important;
}
.add-egnyteEditTip {
    display: inline-block;
    width: 560px;
    color: black;
    letter-spacing: 0.5px;
    /* 你可以根据需要调整间隔值 */
}

.add-4sharedEditTip {
    display: inline-block;
    width: 560px;
    color: black;
    letter-spacing: 0.5px;
    /* 你可以根据需要调整间隔值 */
}

#containerUp {
    margin: 10px 0 5px 0;
    /*no*/
}

.add-icedrive-des {
    position: absolute;
    top: -64px;
    width: 625px;
    height: 34px;
    border-radius: 4px;
    opacity: 1;
    left:-6px;

    /* 自动布局 */
    display: flex;
    flex-direction: row;
    padding: 10px;
    gap: 10px;

    /* 辅助/浅蓝 */
    /* 样式描述：hover */
    background: #F2F7FC;
}

.add-icedriveTip {
    position: static;
    left: -1px !important;
    top: -2px;
    width: 598px;
    height: 36px;
    opacity: 1;
    
    font-family: Roboto;
    font-size: 14px;
    font-weight: 549;
    line-height: 18px;
    text-align: justify;
    letter-spacing: 0em;
    z-index: 1;
    color: #3D3D3D;
}

</style>



// WEBPACK FOOTER //
// src/components/popup/add_cloud_popups/edit_cloud_popup.vue